// Color palette for appliances (hex for pie chart)
export enum Colors {
	BLUE = '#6660ED',
	YELLOW = '#FFC51D',
	RED = '#FF4A50',
	TEAL = '#01F1E3',
	GREEN = '#D4FFC6',
	GRAY = '#5C7D7B',
	ORANGE = '#FFA500',
	BROWN = '#8B4513',
	BLUE_LIGHT = '#4169E1',
	GREEN_LIGHT = '#32CD32',
}

// Color system names for list view
export enum SystemColors {
	PRIMARY = 'primary',
	SUCCESS = 'success',
	WARNING = 'warning',
	DANGER = 'danger',
	WHITE = 'white',
	UNKNOWN = 'unknown',
	ROLLER = 'roller',
	LIGHTNING = 'lightning',
	ENTERTAINMENT = 'entertainment',
	REFRIGERATION = 'refrigeration',
	LAUNDRY_CLEANING = 'laundry-cleaning',
	COOKING = 'cooking',
	ELECTRIC_VEHICLE = 'electric-vehicle',
	VENTILATION = 'ventilation',
	WATER_HEATER = 'water-heater',
	OTHER = 'other',
	HEATING = 'heating',
	POOL = 'pool',
	SOLAR = 'solar',
}

export const applianceColorPalette = Object.values(Colors);
export const applianceSystemColorNames = Object.values(SystemColors);

export const units = 'W';
export const chartHeight = 272;

export const SNAPSHOT_CACHE_KEY = 'infinno_snapshot_cache';
